import {
  isAtom,
  isArray,
  isObject,
} from '../../helper/index.js';

// write actions
const SET_ATOM = 'setAtom';
const PUSH = 'push';
const POP = 'pop';
const REMOVE_KEY = 'removeKey';
const SET_KEY = 'setKey';

/**
 *
 * diff two isomorphic trees
 *
 * @return [{actionType, path, options}]
 */
const diffIsomorphicJsons = (oldSubTree, newSubTree, prevPath = '') => {
  const ans = [];
  diffHelp(oldSubTree, newSubTree, prevPath, ans);
  return ans;
};

// case 1: atom1, atom2 => set
// case 2: array
// case 3: object
const diffHelp = (oldSubTree, newSubTree, path, ans) => {
  // diff atom
  if (isAtom(oldSubTree)) {
    if (!isAtom(newSubTree)) {
      throw new Error(`oldSubTree and newSubTree need to be isomorphic, oldSubTree=${oldSubTree}, newSubTree=${newSubTree}`);
    }

    ans.push({
      path,
      actionType: SET_ATOM,
      options: [newSubTree]
    });

    return;
  }

  // diff array
  if (isArray(oldSubTree)) {
    if (!isArray(newSubTree)) {
      throw new Error(`oldSubTree and newSubTree need to be isomorphic, oldSubTree=${oldSubTree}, newSubTree=${newSubTree}`);
    }

    // if new array is longer, push new items
    if (oldSubTree.length < newSubTree.length) {
      for (let i = oldSubTree.length; i < newSubTree.length; i++) {
        ans.push({
          path,
          actionType: PUSH,
          options: [newSubTree[i]]
        });
      }
    }

    // if new array is smaller, pop old items
    if (oldSubTree.length > newSubTree.length) {
      for (let i = newSubTree.length; i < oldSubTree.length; i++) {
        ans.push({
          path,
          actionType: POP,
          options: []
        });
      }
    }

    for (let i = 0; i < Math.min(oldSubTree.length, newSubTree.length); i++) {
      diffHelp(oldSubTree[i], newSubTree[i], path + '.' + i, ans);
    }
  }

  // diff object
  if (isObject(oldSubTree)) {
    if (!isObject(newSubTree)) {
      throw new Error(`oldSubTree and newSubTree need to be isomorphic, oldSubTree=${oldSubTree}, newSubTree=${newSubTree}`);
    }

    for (let key in oldSubTree) {
      // removed
      if (newSubTree[key] === undefined || newSubTree[key] === null) {
        ans.push({
          path: path + '.' + key,
          actionType: REMOVE_KEY,
          options: []
        });
      } else {
        // updated
        diffHelp(oldSubTree[key], newSubTree[key], path + '.' + key, ans);
      }
    }

    for (let key in newSubTree) {
      // new key
      if (oldSubTree[key] === undefined || oldSubTree[key] === null) {
        ans.push({
          path: path + '.' + key,
          actionType: SET_KEY,
          options: [newSubTree[key]]
        });
      }
    }
  }
};

export {
  SET_ATOM,
  PUSH,
  POP,
  REMOVE_KEY,
  SET_KEY,

  diffIsomorphicJsons
};
